module.exports = __webpack_public_path__ + "media/images/application/template/icon-nbs-specification-243f397c6b1122118c1f377daf47cb98.svg";